function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchUserTransferRating } from '../../../cores/api/api-dashboard';
import BarChart from '../../components/bar-chart';
import { formatTotalUser } from '../../../utils/utils';
import { OPTIONS_FILTER_CHART } from '../../../contants/option';
const EMPTY_TRANSFER = {
    registration_count: 0,
    email_verify_count: 0,
    complete_profile_count: 0,
    sales_subscription_count: 0,
    sales_like_count: 0
};
export default function SectionUserTransferRatingChart() {
    const _React$useState = React.useState('weekly'), _React$useState2 = _slicedToArray(_React$useState, 2), period = _React$useState2[0], setPeriod = _React$useState2[1];
    const _useQuery = useQuery({
        queryKey: ['fetchUserTransferRating', period],
        queryFn: () => fetchUserTransferRating({
            period
        }),
        placeholderData: {
            data: {
                user_transfer_count: EMPTY_TRANSFER,
                total_user_count: 0
            }
        },
        suspense: true
    }), data = _useQuery.data;
    const transfer = (data === null || data === void 0 ? void 0 : data.data.user_transfer_count) || EMPTY_TRANSFER;
    const LABEL_MAP = {
        registration_count: 'アカウント登録',
        email_verify_count: 'メール確認',
        complete_profile_count: 'プロフィール入力',
        sales_subscription_count: 'サブスク',
        sales_like_count: 'いいね'
    };
    const ORDER = ['registration_count', 'email_verify_count', 'complete_profile_count', 'sales_subscription_count', 'sales_like_count'];
    const totals = ORDER.map(k => transfer[k]);
    const maxValue = Math.max(...totals);
    const percents = totals.map(v => Number((v / maxValue * 100).toFixed(1)));
    const labels = ORDER.map(k => LABEL_MAP[k]);
    const barData = {
        labels,
        datasets: [{
                data: percents,
                backgroundColor: '#2563eb',
                borderRadius: 6,
                barThickness: 28
            }]
    };
    return /*#__PURE__*/ React.createElement(BarChart, {
        title: "\u30E6\u30FC\u30B6\u30FC\u9077\u79FB\u72B6\u6CC1",
        userCountText: formatTotalUser({
            value: (data === null || data === void 0 ? void 0 : data.data.total_user_count) || 0
        }),
        options: OPTIONS_FILTER_CHART.filter(opt => opt.key !== 'daily'),
        data: barData,
        onPeriodChange: setPeriod
    });
}
